module.exports = __webpack_public_path__ + "img/popularize-icon3-04.10ad4100.png";